import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
  IconRound,
  NavWrap,
  TopNav,
  TopInner,
  Left,
  LogoWrap,
  Center,
  Brand,
  Right,
  IconPill,
  BurgerBtn,
  MarqueeBar,
  MarqueeInner,
  MarqueeTrack,
  MarqueeItem,
  SubNav,
  SubInner,
  SubLinks,
  SubItem,
  SubLink,
  MobileBottomBar,
  MobileBottomInner,
  CartPill,
  MobileTotal,
  MobileBottomSpacer,
  MobileDropWrap,
  MobileDropInner,
  MobileDropList,
  MobileDropItem,
  MobileDropLink,
  MobileCatsSlot,
  HeaderSpacer,
  UserMenuWrap,
  LogoutToast,
  CartToast,
} from "./MenuBarStyles";

import { useCart } from "../../context/CartContext";
import CategoryTopBar from "../CategoryTopBar/CategoryTopBar";
import Logo from "../../assets/logo.png";

const LINKS = [
  { to: "/", label: "Magazin" },
  { to: "/despre", label: "Despre" },
  { to: "/calitate", label: "Calitate" },
  { to: "/contact", label: "Contact" },
];

const marqueeItems = [
  { icon: "bow", text: "Torturi Personalizate" },
  { icon: "cupcake", text: "Prăjituri artizanale" },
  { icon: "truck", text: "Comandă & Ridică" },
  { icon: "cake", text: "Pentru evenimente" },
];
const MARQUEE_H = 46;

let __ahavaMarqueeOwner = 0;
let __ahavaSeq = 0;

function MarqueeIcon({ name }) {
  switch (name) {
    case "truck":
      return (
        <svg width="18" height="18" viewBox="0 0 24 24">
          <path d="M3 7h11v10H3V7Z" className="stroke" />
          <path d="M14 11h4l3 3v3h-7v-6Z" className="stroke" />
          <path
            d="M7 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
            className="fill"
          />
          <path
            d="M18 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
            className="fill"
          />
        </svg>
      );
    case "cake":
      return (
        <svg width="18" height="18" viewBox="0 0 24 24">
          <path d="M6 10h12v10H6V10Z" className="stroke" />
          <path d="M8 10V8a4 4 0 0 1 8 0v2" className="stroke" />
          <path d="M9 14h6" className="stroke" strokeLinecap="round" />
          <path d="M8.6 12.2h6.8" className="fillSoft" />
        </svg>
      );
    case "cupcake":
      return (
        <svg width="18" height="18" viewBox="0 0 24 24">
          <path d="M8 11c0-2.2 1.8-4 4-4s4 1.8 4 4" className="stroke" />
          <path d="M7 11h10l-1.2 10H8.2L7 11Z" className="stroke" />
          <path d="M9 15h6" className="stroke" strokeLinecap="round" />
          <path d="M8.7 12.4h6.6" className="fillSoft" />
        </svg>
      );
    case "bow":
    default:
      return (
        <svg width="18" height="18" viewBox="0 0 24 24">
          <path
            d="M12 12c2-3 4-4 6-4 1.5 0 2.5 1 2.5 2.5S19.5 13 18 13c-2 0-4-1-6-1Z"
            className="stroke"
          />
          <path
            d="M12 12c-2-3-4-4-6-4C4.5 8 3.5 9 3.5 10.5S4.5 13 6 13c2 0 4-1 6-1Z"
            className="stroke"
          />
          <path d="M12 12v2" className="stroke" strokeLinecap="round" />
          <path d="M11.2 12.1h1.6v1.6h-1.6z" className="fill" />
        </svg>
      );
  }
}

function UserIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M4 20c1.7-4 5-6 8-6s6.3 2 8 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function CartIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M6 7h15l-1.5 9H8L6 7Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M6 7 5 4H2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9 20a1.2 1.2 0 1 0 0-2.4A1.2 1.2 0 0 0 9 20Z"
        fill="currentColor"
      />
      <path
        d="M18 20a1.2 1.2 0 1 0 0-2.4A1.2 1.2 0 0 0 18 20Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default function MenuBar({
  categories = [],
  activeId = null,
  onSelect = () => {},
}) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isMenuPage = pathname === "/";
  const isCartPage = pathname === "/cos" || pathname === "/plasare-comanda";
  const isAuthPage =
    pathname === "/login" ||
    pathname === "/register" ||
    pathname === "/changepsw" ||
    pathname === "/updatepsw";

  const isAccountPage =
    pathname === "/profil" ||
    pathname === "/comenzi" ||
    pathname === "/stoc" ||
    pathname === "/employee-stock";

  const hideFullMenu = isAuthPage || isAccountPage;

  const [open, setOpen] = useState(false);
  const [docked, setDocked] = useState(false);
  const [dropTop, setDropTop] = useState(68);

  const [userOpen, setUserOpen] = useState(false);
  const [logoutMsg, setLogoutMsg] = useState("");

  const getStoredUser = () => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  };

  const [user, setUser] = useState(getStoredUser());
  const role = user?.role;

  useEffect(() => {
    const sync = () => setUser(getStoredUser());
    window.addEventListener("storage", sync);
    window.addEventListener("focus", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("focus", sync);
    };
  }, []);

  useEffect(() => {
    if (!userOpen) return;

    const onDown = (e) => {
      const t = e.target;
      if (!t.closest?.("[data-user-menu]")) setUserOpen(false);
    };

    const onEsc = (e) => {
      if (e.key === "Escape") setUserOpen(false);
    };

    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onEsc);

    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onEsc);
    };
  }, [userOpen]);

  const logout = async () => {
    localStorage.removeItem("user");
    localStorage.removeItem("userEmail");

    setUser(null);
    setUserOpen(false);
    setOpen(false);

    setLogoutMsg("Te-ai delogat cu succes ✨");
    setTimeout(() => {
      setLogoutMsg("");
      navigate("/", { replace: true });
    }, 1400);
  };

  const instanceId = useRef(0);
  if (instanceId.current === 0) instanceId.current = ++__ahavaSeq;

  const [isMarqueeOwner, setIsMarqueeOwner] = useState(false);

  const topRef = useRef(null);
  const subRef = useRef(null);
  const catsRef = useRef(null);

  const { totalProduse, totalPret, toast } = useCart();
  const cartTotal = `${totalPret.toFixed(2)} lei`;

  useLayoutEffect(() => {
    if (hideFullMenu) return;

    const setHeaderH = () => {
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      const topH = topRef.current?.offsetHeight || 0;
      const subH = subRef.current?.offsetHeight || 0;
      const catsH = catsRef.current?.offsetHeight || 0;

      const h = isMobile ? topH + catsH : topH + subH;
      document.documentElement.style.setProperty("--header-h", `${h}px`);
    };

    setHeaderH();
    window.addEventListener("resize", setHeaderH);
    return () => window.removeEventListener("resize", setHeaderH);
  }, [hideFullMenu]);

  useLayoutEffect(() => {
    if (hideFullMenu) return;

    if (__ahavaMarqueeOwner === 0) {
      __ahavaMarqueeOwner = instanceId.current;
      setIsMarqueeOwner(true);
    }

    return () => {
      if (__ahavaMarqueeOwner === instanceId.current) {
        __ahavaMarqueeOwner = 0;
      }
    };
  }, [hideFullMenu]);

  const goHome = (e) => {
    e.preventDefault();
    setOpen(false);
    setUserOpen(false);

    if (pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    navigate("/");
  };

  useEffect(() => {
    if (hideFullMenu) return;

    const onScroll = () => setDocked(window.scrollY >= MARQUEE_H);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => window.removeEventListener("scroll", onScroll);
  }, [hideFullMenu]);

  const calcDropTop = () => {
    const topEl = topRef.current;
    if (!topEl) return 68;
    const rect = topEl.getBoundingClientRect();
    return Math.round(rect.top + rect.height);
  };

  useEffect(() => {
    if (hideFullMenu) return;

    const run = () => setDropTop(calcDropTop());
    run();

    window.addEventListener("resize", run);
    window.addEventListener("scroll", run, { passive: true });

    return () => {
      window.removeEventListener("resize", run);
      window.removeEventListener("scroll", run);
    };
  }, [open, docked, isMarqueeOwner, hideFullMenu]);

  const go = (href) => {
    setOpen(false);

    if (href === "/despre") return navigate("/despre");
    if (href === "/calitate") return navigate("/calitate");
    if (href === "/contact") return navigate("/contact");
    if (href === "/") return navigate("/");

    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const loop = useMemo(() => {
    const base = marqueeItems.concat(marqueeItems);
    return base.concat(base);
  }, []);

  if (isAccountPage) {
    return null;
  }

  if (isAuthPage) {
    return (
      <>
        <MobileBottomBar>
          <MobileBottomInner>
            <CartPill
              aria-label="Coșul meu"
              onClick={(e) => {
                e.preventDefault();
                navigate("/cos");
              }}
              type="button"
            >
              <CartIcon />
              <span className="lbl">
                Coșul meu {totalProduse > 0 ? `(${totalProduse})` : ""}
              </span>
              <span className="sum">{cartTotal}</span>
            </CartPill>
            <MobileTotal />
          </MobileBottomInner>
        </MobileBottomBar>

        <MobileBottomSpacer />
      </>
    );
  }

  return (
    <>
      {logoutMsg && <LogoutToast>{logoutMsg}</LogoutToast>}
      {toast && <CartToast>{toast}</CartToast>}

      {isMarqueeOwner && !isCartPage && (
        <MarqueeBar $hidden={docked}>
          <MarqueeInner>
            <MarqueeTrack>
              {loop.map((it, idx) => (
                <MarqueeItem key={`${it.text}-${idx}`}>
                  <span className="icon">
                    <MarqueeIcon name={it.icon} />
                  </span>
                  <span className="txt">{it.text}</span>
                </MarqueeItem>
              ))}
            </MarqueeTrack>
          </MarqueeInner>
        </MarqueeBar>
      )}

      <NavWrap $docked={docked} $hideMarquee={isCartPage}>
        <TopNav ref={topRef}>
          <TopInner>
            <Left>
              <LogoWrap href="/" onClick={goHome}>
                <img src={Logo} alt="Ahava Cakes logo" />
              </LogoWrap>
            </Left>

            <Center>
              <Brand href="/" onClick={goHome}>
                AHAVA <span>CAKES</span>
              </Brand>
            </Center>

            <Right>
              <UserMenuWrap data-user-menu>
                <IconPill
                  href="#cont"
                  onClick={(e) => {
                    e.preventDefault();
                    setOpen(false);
                    if (!user) return navigate("/login");
                    setUserOpen((v) => !v);
                  }}
                  aria-label="Cont"
                  title="Cont"
                >
                  <UserIcon />
                  <span
                    style={{
                      color: "rgba(255,255,255,0.92)",
                      fontWeight: 900,
                      letterSpacing: "0.14em",
                      fontSize: 11,
                      textTransform: "uppercase",
                    }}
                  >
                    Cont
                  </span>
                </IconPill>

                <IconRound
                  type="button"
                  aria-label="Cont"
                  onClick={() => {
                    setOpen(false);
                    if (!user) return navigate("/login");
                    setUserOpen((v) => !v);
                  }}
                  title="Cont"
                >
                  <UserIcon />
                </IconRound>

                {userOpen && user && (
                  <div
                    style={{
                      position: "absolute",
                      right: 0,
                      top: "calc(100% + 10px)",
                      zIndex: 9999,
                      width: "min(320px, calc(100vw - 90px))",
                    }}
                  >
                    <MobileDropInner $open={userOpen}>
                      <MobileDropList>
                        {role === "utilizator" && (
                          <>
                            <MobileDropItem>
                              <MobileDropLink
                                as="button"
                                type="button"
                                onClick={() => {
                                  setUserOpen(false);
                                  navigate("/profil");
                                }}
                              >
                                Profil
                              </MobileDropLink>
                            </MobileDropItem>

                            <MobileDropItem>
                              <MobileDropLink
                                as="button"
                                type="button"
                                onClick={() => {
                                  setUserOpen(false);
                                  navigate("/comenzi");
                                }}
                              >
                                Comenzi
                              </MobileDropLink>
                            </MobileDropItem>
                          </>
                        )}

                        {role === "admin" && (
                          <>
                            <MobileDropItem>
                              <MobileDropLink
                                as="button"
                                type="button"
                                onClick={() => {
                                  setUserOpen(false);
                                  navigate("/comenzi");
                                }}
                              >
                                Comenzi
                              </MobileDropLink>
                            </MobileDropItem>

                            <MobileDropItem>
                              <MobileDropLink
                                as="button"
                                type="button"
                                onClick={() => {
                                  setUserOpen(false);
                                  navigate("/stoc");
                                }}
                              >
                                Produse
                              </MobileDropLink>
                            </MobileDropItem>
                          </>
                        )}

                        {role === "angajat" && (
                          <>
                            <MobileDropItem>
                              <MobileDropLink
                                as="button"
                                type="button"
                                onClick={() => {
                                  setUserOpen(false);
                                  navigate("/comenzi");
                                }}
                              >
                                Comenzi
                              </MobileDropLink>
                            </MobileDropItem>

                            <MobileDropItem>
                              <MobileDropLink
                                as="button"
                                type="button"
                                onClick={() => {
                                  setUserOpen(false);
                                  navigate("/employee-stock");
                                }}
                              >
                                Stoc
                              </MobileDropLink>
                            </MobileDropItem>
                          </>
                        )}

                        <MobileDropItem>
                          <MobileDropLink
                            as="button"
                            type="button"
                            onClick={logout}
                          >
                            Logout
                          </MobileDropLink>
                        </MobileDropItem>
                      </MobileDropList>
                    </MobileDropInner>
                  </div>
                )}
              </UserMenuWrap>

              <IconPill
                href="/cos"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/cos");
                }}
                aria-label="Coș"
                title="Coș"
              >
                <CartIcon />
                <span
                  style={{
                    color: "rgba(255,255,255,0.92)",
                    fontWeight: 900,
                    letterSpacing: "0.14em",
                    fontSize: 11,
                    textTransform: "uppercase",
                  }}
                >
                  Coș {totalProduse > 0 ? `(${totalProduse})` : ""}
                </span>
              </IconPill>

              <BurgerBtn
                type="button"
                aria-label="Deschide meniul"
                aria-expanded={open}
                onClick={() => setOpen((v) => !v)}
              >
                <span />
                <span />
                <span />
              </BurgerBtn>
            </Right>
          </TopInner>

          <MobileDropWrap $open={open} $top={dropTop}>
            <MobileDropInner $open={open}>
              <MobileDropList>
                {LINKS.map((l) => (
                  <MobileDropItem key={l.to}>
                    <MobileDropLink
                      href={l.to}
                      onClick={(e) => {
                        e.preventDefault();
                        go(l.to);
                      }}
                    >
                      {l.label}
                    </MobileDropLink>
                  </MobileDropItem>
                ))}
              </MobileDropList>
            </MobileDropInner>
          </MobileDropWrap>
        </TopNav>

        {isMenuPage && (
          <MobileCatsSlot ref={catsRef}>
            <CategoryTopBar
              categories={categories}
              activeId={activeId}
              onSelect={onSelect}
            />
          </MobileCatsSlot>
        )}

        <SubNav aria-label="Navigație" ref={subRef}>
          <SubInner>
            <SubLinks>
              {LINKS.map((l) => (
                <SubItem key={l.to}>
                  <SubLink
                    href={l.to}
                    onClick={(e) => {
                      e.preventDefault();
                      go(l.to);
                    }}
                  >
                    {l.label}
                  </SubLink>
                </SubItem>
              ))}
            </SubLinks>
          </SubInner>
        </SubNav>

        <MobileBottomBar>
          <MobileBottomInner>
            <CartPill
              aria-label="Coșul meu"
              onClick={() => navigate("/cos")}
              type="button"
            >
              <CartIcon />
              <span className="lbl">
                Coșul meu {totalProduse > 0 ? `(${totalProduse})` : ""}
              </span>
              <span className="sum">{cartTotal}</span>
            </CartPill>
            <MobileTotal />
          </MobileBottomInner>
        </MobileBottomBar>
      </NavWrap>

      <HeaderSpacer />
      <MobileBottomSpacer />
    </>
  );
}
